const docsToShipmentRecords = require('./tools/docs-to-shipment-records')

module.exports = async (state, parentDocId, { isAutomaticReturnShipment }) => {
  try {
    const doc = await state.dal.shipment.getByParentDocId(state, parentDocId, { isAutomaticReturnShipment })
    if (doc) {
      const [transformedDoc] = docsToShipmentRecords(null, [doc], {})
      return transformedDoc
    }
    return doc
  } catch (error) {
    console.error(`Error getting shipment by parentDocId ${parentDocId}`, error)
    throw new Error('Error checking for existing return shipment')
  }
}
